const INIT_REVISIONS = 'fulcrum/container/project/revision/INIT_REVISIONS'
const LOAD_REVISION_DATA = 'fulcrum/container/project/revision/LOAD_REVISION_DATA'
const LOAD_REVISION_DATA_SUCCESS = 'fulcrum/container/project/revision/LOAD_REVISION_DATA_SUCCESS'

const UPDATE_CURRENT_REVISION = 'fulcrum/container/project/revision/UPDATE_CURRENT_REVISION'
const UPDATE_OLDEST_REVISION = 'fulcrum/container/project/revision/UPDATE_OLDEST_REVISION'
const UPDATE_LATEST_REVISION = 'fulcrum/container/project/revision/UPDATE_LATEST_REVISION'
const UPDATE_ORIGINAL_REVISION = 'fulcrum/container/project/revision/UPDATE_ORIGINAL_REVISION'
const UPDATE_MODIFIED_REVISION = 'fulcrum/container/project/revision/UPDATE_MODIFIED_REVISION'
const UPDATE_REVISIONS = 'fulcrum/container/project/revision/UPDATE_REVISIONS'

const POST_PROJECT_REVISION = 'fulcrum/containers/project/revision/POST_PROJECT_REVISION'
const POST_PROJECT_REVISION_START = 'fulcrum/containers/project/revision/POST_PROJECT_REVISION_START'
const POST_PROJECT_REVISION_SUCCESS = 'fulcrum/containers/project/revision/POST_PROJECT_REVISION_SUCCESS'
const POST_PROJECT_REVISION_ERROR = 'fulcrum/containers/project/revision/POST_PROJECT_REVISION_ERROR'

const FETCH_PROJECT_REVISIONS = 'fulcrum/containers/project/revision/FETCH_PROJECT_REVISIONS'
const FETCH_PROJECT_REVISIONS_START = 'fulcrum/containers/project/revision/FETCH_PROJECT_REVISIONS_START'
const FETCH_PROJECT_REVISIONS_SUCCESS = 'fulcrum/containers/project/revision/FETCH_PROJECT_REVISIONS_SUCCESS'
const FETCH_PROJECT_REVISIONS_ERROR = 'fulcrum/containers/project/revision/FETCH_PROJECT_REVISIONS_ERROR'

const FETCH_REVISION_DATA = 'fulcrum/containers/project/revision/FETCH_REVISION_DATA'
const FETCH_REVISION_DATA_START = 'fulcrum/containers/project/revision/FETCH_REVISION_DATA_START'
const FETCH_REVISION_DATA_SUCCESS = 'fulcrum/containers/project/revision/FETCH_REVISION_DATA_SUCCESS'
const FETCH_REVISION_DATA_ERROR = 'fulcrum/containers/project/revision/FETCH_REVISION_DATA_ERROR'

export {
  INIT_REVISIONS,
  LOAD_REVISION_DATA,
  LOAD_REVISION_DATA_SUCCESS,
  UPDATE_REVISIONS,
  UPDATE_CURRENT_REVISION,
  UPDATE_OLDEST_REVISION,
  UPDATE_LATEST_REVISION,
  UPDATE_ORIGINAL_REVISION,
  UPDATE_MODIFIED_REVISION,
  POST_PROJECT_REVISION,
  POST_PROJECT_REVISION_START,
  POST_PROJECT_REVISION_SUCCESS,
  POST_PROJECT_REVISION_ERROR,
  FETCH_PROJECT_REVISIONS,
  FETCH_PROJECT_REVISIONS_START,
  FETCH_PROJECT_REVISIONS_SUCCESS,
  FETCH_PROJECT_REVISIONS_ERROR,
  FETCH_REVISION_DATA,
  FETCH_REVISION_DATA_START,
  FETCH_REVISION_DATA_SUCCESS,
  FETCH_REVISION_DATA_ERROR,
}
